<script setup>
import {useStore} from "vuex";
import {computed} from "vue";

// Vuex
const store = useStore();
// Computed
const sectionToolBadgeColor = computed(() => {
  return store.getters.isSectionToolActive ? 'success' : 'error';
});
const activeRightPanelTab = computed({
  get() {
    return store.getters.getViewerRightPanelTab;
  },
  set(value) {
    store.commit('setViewerRightPanelTab', value);
  }
});

</script>

<template>
  <v-toolbar elevation="1">
    <v-toolbar-items>
      <v-btn icon="mdi-image-filter-center-focus-strong"
             :title="$t('titles.fitScreen')"
             stacked
             @click="store.commit('fitViewerScene')"
      ></v-btn>
      <v-btn :title="$t('titles.selectionTool')"
             stacked
             @click="store.commit('toggleSectionTool')"
      >
        <v-badge dot
                 :color="sectionToolBadgeColor"
        >
          <v-icon icon="mdi-table-split-cell"></v-icon>
        </v-badge>
      </v-btn>
      <v-btn icon="mdi-image-filter-center-focus-strong-outline"
             :title="$t('titles.fitSelectionBox')"
             stacked
             @click="store.commit('fitSectionBoxToModel')"
      ></v-btn>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-tabs v-model="activeRightPanelTab"
            align-tabs="end"
            density="comfortable"
            color="secondary"
    >
      <v-tab value="comments">{{ $t('comment', 2).capitalize() }}</v-tab>
      <v-tab value="filters">{{ $t('filter', 2).capitalize() }}</v-tab>
    </v-tabs>
  </v-toolbar>
</template>

<style scoped>

</style>
